import { useState } from 'react';

import { Flex } from 'components/flex';
import { SectionHeaderExpandable } from 'components/section-header';
import { CustomCssTransition } from 'components/custom-css-transition';

import * as Styles from './styles';
import { SectionProps } from './types';

export const ExpandableSection = ({
  label,
  gap = 16,
  children,
  customHeader,
  defaultOpened = true,
}: SectionProps) => {
  const [isOpened, setIsOpened] = useState(defaultOpened);

  const onToggle = () => setIsOpened(!isOpened);

  return (
    <Flex gap={gap} flexDirection="column">
      {customHeader?.(isOpened, onToggle) || (
        <SectionHeaderExpandable
          title={label}
          isOpened={isOpened}
          onToggle={onToggle}
        />
      )}

      <CustomCssTransition
        in={isOpened}
        timeout={300}
        unmountOnExit
        classNames="expand"
      >
        <Styles.Container>{children}</Styles.Container>
      </CustomCssTransition>
    </Flex>
  );
};

export type { SectionProps };
